import React, { Component } from 'react';
import '../styles/Header.scss';
import { Auth } from 'aws-amplify';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withTranslation } from 'react-i18next';
import { getPoolInformation } from '../services/tenant-identity-service';
import { deleteCookie } from '../services/cookie-storage-service';


let gatsbyUrl = process.env.REACT_APP_GATSBY_APPLICATION_URL;

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageUrl: this.props.location.pathname,
            tenantData: {}
        }
    }

    componentDidMount = () => {
        let tenantGuid = localStorage.getItem("tenantGuid");
        this.getTenantDetails(tenantGuid);
    }

    getTenantDetails = async (tenantGuid) => {
        try {
            let tenantData = await getPoolInformation(tenantGuid);
            this.setState({ tenantData: tenantData });
        } catch (error) {
            console.log('getTenantDetails error', error);
        }
    }

    handleLogOut = async event => {
        event.preventDefault();

        try {
            let currentLanguage = localStorage.getItem("languageCode");

            Auth.signOut();
            this.props.auth.setAuthStatus(false);
            this.props.auth.setUser(null);
            localStorage.clear();
            deleteCookie();

            if (currentLanguage) {
                if (currentLanguage === 'en') {
                    window.location.replace(`${gatsbyUrl}/login`);
                } else {
                    window.location.replace(`${gatsbyUrl}/${currentLanguage}/login`);
                }
            } else {
                window.location.replace(`${gatsbyUrl}/login`);
            }

        } catch (error) {
            console.log(error.message);
        }
    }

    navigate = (e, name) => {
        let pagename = name.substr(1,);
        let tenantData = this.props.auth.tenantResult;
        // let isPurchase = tenantData.isPurchase;
        let languageCount = tenantData.languageCount;
        let locationCount = tenantData.locationCount;


        if (languageCount > 0 && pagename === 'Location') {
            this.props.history.push(name);
        }
        else if (locationCount > 0 && languageCount > 0) {
            this.props.history.push(name);
        } else {
            e.preventDefault();
        }
    }

    render() {
        // console.log('Header.js render result*****************', this.state);
        const { t } = this.props;
        let isTenantPurchased = false;
        isTenantPurchased = localStorage.getItem('isTenantPurchased');

        // if (this.props.auth.tenantResult != null && this.props.auth.tenantResult != '' && this.props.auth.tenantResult != undefined) {
        //     isTenantPurchased = this.props.auth.tenantResult.isPurchase;
        // } else {
        //     isTenantPurchased = this.state.tenantData.isPurchase;
        // }

        let active = {
            color: "#10aee5"
        }

        let disable = {
            color: '#1a2e54'
        }

        let currentPage = this.props.location.pathname.substr(1,);
        let pagename = this.props.location.pathname.substr(1,);

        return (
            <div className="head-tab-sec">

                {/* <h6>{this.props.location.pathname.substr(1,)}</h6> <ArrowForwardIosIcon/>
                <h6>Locations</h6>  <ArrowForwardIosIcon/>
                <h6>Products</h6>  <ArrowForwardIosIcon/> */}
                {/* 
                {this.state.items.map((item, i) => {
                    this.props.location.pathname == item ?  (
                        <NavLink to="/Language" className="nav-link">LANGUAGES</NavLink> <ArrowForwardIosIcon />
                    ):null
                    
                })} */}

                {(this.props.location.state || this.props.location.pathname === '/Summary') && (isTenantPurchased) ? (
                    <div className="align-header-content">
                        <div className="header-element">{t(pagename)}</div>
                        <div className="header-element" style={{ cursor: "pointer" }} onClick={this.handleLogOut} >{t('Sign Out')}</div>
                    </div>

                ) : (
                    <div className="align-header-arrow-content">
                        <div className="header-element">{t('Purchases')} : </div>
                        {/* <div className="nav-link header-arrow-element" >Items</div><ArrowForwardIosIcon className="arrow" /> */}
                        {/* <div className="nav-link header-arrow-element" style={currentPage === 'Language' ? active : disable} onClick={(e) => this.navigate(e, '/Language')}>{t('Languages')}</div> <ArrowForwardIosIcon className="arrow" />
                        <div className="nav-link header-arrow-element" style={currentPage === 'Location' ? active : disable} onClick={(e) => { this.navigate(e, '/Location') }}>{t('Locations')}</div> <ArrowForwardIosIcon className="arrow" />
                        <div className="nav-link header-arrow-element" style={currentPage === 'AddOns' ? active : disable} onClick={(e) => this.navigate(e, '/AddOns')}>{t('AddOns')}</div> <ArrowForwardIosIcon className="arrow" /> */}
                        <div className="nav-link header-arrow-element" style={currentPage === 'Subscription_Upgrade' || currentPage === 'AddOns' ? active : disable} >Items</div> <ArrowForwardIosIcon className="arrow" />

                        <div className="nav-link header-arrow-element" style={currentPage === 'Purchases' ? active : disable} onClick={(e) => { this.navigate(e, '/Purchases') }}>{t('Overview')}</div> <ArrowForwardIosIcon className="arrow" />

                        {/* <div className="nav-link header-arrow-element" style={currentPage === ('Billing' || 'Bill') ? active : disable} onClick={(e) => { this.navigate(e, '/Billing') }}>{t('Billing' || 'Bill')}</div> <ArrowForwardIosIcon className="arrow" /> */}

                        <div className="nav-link header-arrow-element" style={currentPage === 'Billing' || currentPage === 'Bill' ? active : disable} onClick={(e) => { this.navigate(e, '/Billing') }}>{t('Billing' || 'Bill')}</div> <ArrowForwardIosIcon className="arrow" />

                        <div className="nav-link header-arrow-element" style={currentPage === 'Payment' || currentPage === 'Success' ? active : disable} onClick={(e) => { this.navigate(e, '/Payment') }}>{t('Payment')}</div>

                        <div className="signout header-element" onClick={this.handleLogOut} >{t('Sign Out')}</div>
                    </div>
                )

                }

                {/* <ul className="nav nav-pills demo-tab">
                    <li className="nav-item">
                        <div className="nav-link" onClick={this.handleLogOut}>Sign Out</div>
                    </li>
                </ul> */}
            </div>
        )
    }
}
export default withTranslation()(Header)